import { render } from "./AdminDashBoardReport.vue?vue&type=template&id=78a728b1&ts=true"
import script from "./AdminDashBoardReport.vue?vue&type=script&lang=ts"
export * from "./AdminDashBoardReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__